'use client'
import { ServicesData } from '@/db/services'
import React from 'react'
import ServiceCard from './ServiceCard'
import { useGetHeroServices } from '@/lib/hooks/admin-dashboard/hero-services/get/useGetHeroServices'

const ServiceList = () => {
  const { data, isLoading } = useGetHeroServices();
  const heroServices = data as HeroServices[];
  if (isLoading) return <p>Loading...</p>;
  return (
    <div className='flex justify-around gap-y-4 sm:gap-8 flex-wrap'>
      {
        heroServices.map((service, index) => (
          <ServiceCard key={index} service={service} />
        ))
      }
    </div>
  )
}

export default ServiceList
